/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Form/view.blocks to change it.
import City from './City/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import Zip from './Zip/index'



/** @type {import('Simple/types.js').View} */
export default function Form({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/Content/Form"
  
}) {
  return (<React.Fragment
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
{children}
</React.Fragment>)
}